import { render, staticRenderFns } from "./Companydetails.vue?vue&type=template&id=0ea2230b"
import script from "./Companydetails.vue?vue&type=script&lang=js"
export * from "./Companydetails.vue?vue&type=script&lang=js"
import style0 from "./Companydetails.vue?vue&type=style&index=0&id=0ea2230b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports